import { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";
import {
  buildCompetitionAdminRoutes,
  resolveCompetitionAdminScope,
} from "constants/competition-admin-routes";

export function useCompetitionAdminRoutes(competitionIdOverride) {
  const location = useLocation();
  const params = useParams();
  const competitionId = competitionIdOverride || params.id;
  const scope = resolveCompetitionAdminScope(location.pathname, params);

  return useMemo(
    () => buildCompetitionAdminRoutes(competitionId, scope?.customerId ?? null),
    [competitionId, scope?.customerId, location.pathname],
  );
}
